"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getClearBitLogo;
var CLEAR_BIT_PATH = '//logo.clearbit.com';
var CLEAR_BIT_BLACKLIST = ['gmail.com'];
function getClearBitLogo() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (CLEAR_BIT_BLACKLIST.includes(domain)) {
    return '';
  }
  return "".concat(CLEAR_BIT_PATH, "/").concat(domain);
}